import { useServices } from 'app/hooks';
import { useEffect } from 'react';
import {
    selectSymbolStaticDataState,
    SymbolStaticDataState,
} from 'symbols/store/symbolStaticDataSlice';
import { useSelector } from 'react-redux';

export function useSymbolStaticData(): SymbolStaticDataState {
    const { symbolsService } = useServices();
    const staticData = useSelector(selectSymbolStaticDataState);

    useEffect(() => {
        symbolsService.fetchStaticData();
    }, [symbolsService]);

    return staticData;
}
